(ns assemble.component.delete-template-modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Dialog$default" :as Dialog]
            ["@mui/material/DialogActions$default" :as DialogActions]
            ["@mui/material/DialogContent$default" :as DialogContent]
            ["@mui/material/DialogTitle$default" :as DialogTitle]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Typography$default" :as Typography]
            [assemble.resource.template :as resource.template]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-event-db ::open-confirmation-modal
  (fn [db [_ template-id linked-to-adsets?]]
    (assoc db :template-delete {:modal-open true
                                :template-id template-id
                                :linked-to-adsets? linked-to-adsets?})))

(defn close-confirmation-modal [db]
  (assoc db :template-delete {:modal-open false}))

(rf/reg-event-db ::close-confirmation-modal
  (fn [db _]
    (close-confirmation-modal db)))

(rf/reg-event-fx ::delete-template
  (fn [{:keys [db]} [_ template-id]]
    {:db (close-confirmation-modal db)
     :fx [[:dispatch [::resource.template/delete template-id]]]}))

(rf/reg-event-fx ::archive-template
  (fn [{:keys [db]} [_ template-id current-node-id]]
    {:db (close-confirmation-modal db)
     :fx [[:dispatch [::resource.template/patch
                      [::resource.template/template-patch-success current-node-id nil]
                      [::resource.template/template-patch-failure nil]
                      template-id {:archived true}]]]}))

(rf/reg-sub ::modal-open
  (fn [db]
    (get-in db [:template-delete :modal-open] false)))

(rf/reg-sub ::template-id
  (fn [db]
    (get-in db [:template-delete :template-id] false)))

(rf/reg-sub ::linked-to-adsets?
  (fn [db]
    (get-in db [:template-delete :linked-to-adsets?] false)))

(defui confirmation-modal []
  (let [open? (use-subscribe [::modal-open])
        template-id (use-subscribe [::template-id])
        linked-to-adsets? (use-subscribe [::linked-to-adsets?])
        current-node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])]
    ($ Dialog
       {:open open?
        :onClose #(rf/dispatch ::close-confirmation-modal)
        :fullWidth true
        :maxWidth "xs"}
       ($ DialogTitle {:variant "h2"}
          ($ Icon
             {:sx #js {:mr 2 :mb "-3px"}
              :color "error"}
             "error")
          "Delete template")
       (if linked-to-adsets?
         ($ :<>
            ($ DialogContent
               ($ Typography {:sx #js {:fontWeight "bold"}} "Your template cannot be deleted because it is already in use.")
               "You can instead choose to archive it, which will hide it from your view.")
            ($ DialogActions
               ($ Button
                  {:color "primary"
                   :onClick #(rf/dispatch [::close-confirmation-modal])}
                  "Cancel")
               ($ Button
                  {:variant "contained"
                   :color "error"
                   :onClick #(rf/dispatch [::archive-template template-id current-node-id])}
                  "Archive")))
         ($ :<>
            ($ DialogContent
               ($ Typography {:sx #js {:fontWeight "bold"}} "You're about to permanently delete this template, and all of its data.")
               "Deleting this means that the template can no longer be accessed and is no
            longer available for others to use.
            This cannot be undone.")
            ($ DialogActions
               ($ Button
                  {:color "primary"
                   :onClick #(rf/dispatch [::close-confirmation-modal])}
                  "Cancel")
               ($ Button
                  {:variant "contained"
                   :color "error"
                   :onClick #(rf/dispatch [::delete-template template-id])}
                  "Delete")))))))
